import * as types from '../../actionTypes';

const initialState = {
    error: {},
    loading: {}
}


export const saveMasterListValueReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SAVE_MASTER_LIST_VALUE_LOADING:
            return {
                ...state,
                loading: true
            }
        case types.SAVE_MASTER_LIST_VALUE_SUCCESS:
            return {
                ...state,
                loading: false
            }
        case types.SAVE_MASTER_LIST_VALUE_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
            }
        default:
            return state
    }
}